export default {
    locate: 'Locate',
    notAvailable: 'Non Disponible',
    order: 'Commande',
    stock: 'En Stock',
    inTransit: 'En Transit',
};
